<template>
    <div class="animated-number">
        <!-- 每个数字单独处理 -->
        <div class="digit-wrapper" v-for="(digit, index) in digitCount" :key="index" :style="{
            width: digitWidth,
            height: digitHeight,
            'font-size': fontSize
        }">
            <!-- 数字翻页容器 -->
            <div class="digit-roller">
                <div class="digit-track" :style="{
                    transform: `translateY(-${currentDigits[index] * 100}%)`,
                    transition: `transform ${duration}ms ease-out`
                }">
                    <!-- 生成0-9的数字列表 -->
                    <div v-for="n in 10" :key="n" class="digit-item">{{ n % 10 }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AnimatedNumber',
    props: {
        // 目标数值
        value: {
            type: Number,
            required: true,
            default: 0
        },
        // 数字位数，不足时前面补零
        minDigits: {
            type: Number,
            default: 6
        },
        // 动画持续时间(毫秒)
        duration: {
            type: Number,
            default: 1000
        },
        // 单个数字宽度
        digitWidth: {
            type: String,
            default: '40px'
        },
        // 单个数字高度
        digitHeight: {
            type: String,
            default: '50px'
        },
        // 字体大小
        fontSize: {
            type: String,
            default: '36px'
        }
    },
    data() {
        return {
            currentValue: 0, // 当前显示的数值
            timer: null,     // 动画定时器
            digitCount: 0    // 数字总位数
        }
    },
    computed: {
        // 当前显示的每位数字
        currentDigits() {
            // 将当前值转为字符串并补零
            const str = this.currentValue.toString().padStart(this.digitCount, '0')
            // 转为数字数组
            return str.split('').map(Number)
        }
    },
    watch: {
        // 监听目标值变化，触发动画
        value(newVal) {
            this.startAnimation(newVal)
        },
        // 监听最小位数变化，更新位数
        minDigits(newVal) {
            this.digitCount = Math.max(newVal, this.value.toString().length)
        }
    },
    mounted() {
        // 初始化数字位数
        this.digitCount = Math.max(this.minDigits, this.value.toString().length)
        // 启动初始动画
        this.startAnimation(this.value)
    },
    methods: {
        // 开始数字增长动画
        startAnimation(targetValue) {
            // 清除之前的定时器
            if (this.timer) {
                clearInterval(this.timer)
            }

            const startValue = this.currentValue
            const diff = targetValue - startValue

            // 如果目标值小于当前值，直接更新
            if (diff < 0) {
                this.currentValue = targetValue
                return
            }

            // 计算动画步数
            const stepTime = 30 // 每步时间间隔
            const totalSteps = Math.max(Math.floor(this.duration / stepTime), 1)
            const stepValue = diff / totalSteps

            let currentStep = 0

            this.timer = setInterval(() => {
                currentStep++
                // 计算当前值（取整数）
                this.currentValue = Math.floor(startValue + stepValue * currentStep)

                // 到达目标值或完成所有步骤
                if (currentStep >= totalSteps || this.currentValue >= targetValue) {
                    this.currentValue = targetValue
                    clearInterval(this.timer)
                    this.timer = null
                }
            }, stepTime)
        }
    },
    beforeDestroy() {
        // 清除定时器
        if (this.timer) {
            clearInterval(this.timer)
        }
    }
}
</script>

<style scoped>
.animated-number {
    display: inline-flex;
    gap: 5px;
    /* 数字之间的间距 */
}

.digit-wrapper {
    position: relative;
    overflow: hidden;
    border-radius: 4px;
    background-color: #0a1929;
    box-shadow: 0 0 8px rgba(0, 240, 255, 0.2);
}

.digit-roller {
    position: relative;
    width: 100%;
    height: 100%;
}

.digit-track {
    width: 100%;
    will-change: transform;
    /* 优化动画性能 */
}

.digit-item {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    color: #00f0ff;
}
</style>